import { Button, } from "@mui/material";
import Grid from '@mui/material/Grid';
import { OrderWithItems } from 'common-models';
import { FC } from "react";
import { useReopenShoppingCartMutation } from "../../features/events/eventShopApiSlice";
import PageIsLoading from "../PageIsLoading";
import { SwishPaymentFailed } from "./Swish/SwishPaymentFailed";

type PaymentFailedViewProps = {
    order: OrderWithItems,
}

const PaymentFailedView: FC<PaymentFailedViewProps> = ({ order }) => {
    const [reopenShoppingCart] = useReopenShoppingCartMutation();

    const resetCart = async () => {
        await reopenShoppingCart({ cartId: order.cartId, orderId: order.id });
        window.location.reload()
    }

    return (
        <>
            {
                order === undefined ? (
                    <PageIsLoading />
                ) : (
                    <Grid container >
                        <Grid container>
                            Betalningen misslyckades tyvärr!
                        </Grid>
                        <Grid container>
                            <SwishPaymentFailed order={order} />
                        </Grid>
                        <Grid container>
                            <Button onClick={resetCart} variant='contained'>Gå tillbaka till kassan</Button>.
                        </Grid>
                    </Grid>

                )
            }
        </>
    );
    // }
};

export { PaymentFailedView };
